import { createContext, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const ServiceContext = createContext(null);

export const ServiceProvider = ({ children }) => {
  const [serviceName, setServiceName] = useState("");
  const location = useLocation();

  useEffect(() => {
    if (location.state?.serviceName) {
      setServiceName(location.state.serviceName);
      localStorage.setItem("serviceName", location.state.serviceName);
    } else {
      const storedService = localStorage.getItem("serviceName");
      if (storedService) {
        setServiceName(storedService);
      }
    }
  }, [location.state]);

  return (
    <ServiceContext.Provider value={{ serviceName, setServiceName }}>
      {children}
    </ServiceContext.Provider>
  );
};

// Custom hook (clean & reusable)
export const useService = () => {
  const context = useContext(ServiceContext);
  if (!context) {
    throw new Error("useService must be used inside ServiceProvider");
  }
  return context;
};
